import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { ModelloCompagnia } from 'src/app/models/modello-compagnia';
import { ModelloCompagniaService } from 'src/app/services/modello-compagnia.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { ModelloCompagnieFormComponent } from 'src/app/anagrafiche/modello-compagnia/dialogs/form/form.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { saveAs } from 'file-saver';


@Component({
  selector: 'modello-compagnia',
  templateUrl: './modello-compagnia.component.html',
  styleUrls: ['./modello-compagnia.component.scss']
})
export class ModelloCompagniaComponent implements OnInit {
;
  notShowDelete: boolean = true;

  form: FormGroup;

  modello_compagnia : ModelloCompagnia;

  headingText: string = 'Modelli Compagnia';

  relations: string[] = ['compagnia'];


  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'ID',
        internalName: 'id',
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Compagnia',
        internalName: 'compagnia',

        displayFunction: (model) => model.compagnia?.nome,
        sortDisabled: true,
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Condizione',
        internalName: 'nome_condizione',
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Modello',
        internalName: 'cod_modello',
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Edizione',
        internalName: 'edizione',
      }
    ),
  ];

  constructor(
    private fb: FormBuilder,
    public modelloCompagniaService: ModelloCompagniaService,
    private auth: AuthService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<ModelloCompagniaComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona un modello compagnia';
    }
  }

  isUserAdmin(): boolean {
    const user = this.auth.getLoggedInUserFromLocalStorage();
    return user.ruoli[0].nome === "Amministratore";
  }


  async ngOnInit() {};



  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model: ModelloCompagnia) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }

  downloadFunction = (modelloCompagnia: ModelloCompagnia) => {
    this.modelloCompagniaService.downloadFile(modelloCompagnia.id).subscribe(
      (response) => {
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'download';
        if (contentDisposition) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(contentDisposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
          }
        }
        const blob = new Blob([response.body], { type: response.headers.get('Content-Type') });
        saveAs(blob, filename);
        this.toast.success('Modello scaricato.');
      },
      (error) => {
        console.error('Errore durante il download del file', error);
        this.toast.error('Errore durante il download del modello.')
      }
    );
  }

    deleteFunction = async (modelloCompagniaService: ModelloCompagnia) => {
      try {
        let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `sei sicuro di voler eliminare il modello "${modelloCompagniaService.compagnia.nome}" con id ${modelloCompagniaService.id}? ` } });
        dialogRef.afterClosed().subscribe(async data => {
          if (data) {
            await this.modelloCompagniaService.delete(modelloCompagniaService);
            this.toast.success('Modello eliminato.');
            this.updateDataSource();
          }
        });
      } catch (e) {
        console.error(e);
        this.toast.error("Eliminazione modello fallita.", "Errore!");
      }
    }


  editFunction = async (modelloCompagnia: ModelloCompagnia) => {
    try {
      let dialogRef = this.dialog.open(ModelloCompagnieFormComponent, { data: modelloCompagnia });
      dialogRef.afterClosed().subscribe(async (data: ModelloCompagnia) => {
        if (data) {
          data.id = modelloCompagnia.id
          await this.modelloCompagniaService.edit(data);
          this.toast.success('Modello modificato');
          this.updateDataSource();

          if (data.nome_file && typeof data.nome_file === 'object') {
            this.uploadFile(data.id, data.nome_file["_files"][0])
          }
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Modifica modello fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(ModelloCompagnieFormComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => {
      if (data) {
        this.handleCreation(data);

      }
    });
  }

  async handleCreation(formData: any) {
    if (formData) {
      try {

        const prova = formData.nome_file
        formData.nome_file =null
        const newCompany = new ModelloCompagnia().deserialize({ ...formData });
        const createdCompany = await this.modelloCompagniaService.create(newCompany);

        formData.nome_file = prova
        if(formData.nome_file){
          debugger
          if (formData.nome_file._files[0]) {
            await this.uploadFile(createdCompany.id, formData.nome_file._files[0]);
          }
        }
        this.toast.success('Modello caricato con successo!');
        this.updateDataSource();
      }
      catch (e) {
        console.error('Errore durante la creazione del modello:', e);
        this.toast.error('Creazione modello fallita.', 'Errore!');
      }
    }
  }

  async uploadFile(id: number, file: File) {
    if (id && file) {
      const formData = new FormData();
      formData.append('nome_file', file);
      try {
        await this.modelloCompagniaService.uploadFile(id, formData);
        this.toast.success('File caricato con successo');
      } catch (error) {
        console.error('Errore durante il caricamento del file:', error);
        this.toast.error('Caricamento file fallito', 'Errore!');
      }
    } else {
      console.error('ID della compagnia o file non disponibile per il caricamento');
      this.toast.error('Impossibile caricare il file: dati mancanti', 'Errore!');
    }
  }
}
